var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_13964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7781 1.22192C13.2312 -0.324951 10.7125 -0.324951 9.16562 1.22192L6.91875 3.4688C6.60938 3.77817 6.60938 4.2813 6.91875 4.59067C7.22812 4.90005 7.73125 4.90005 8.04062 4.59067L10.2875 2.34692C11.2156 1.4188 12.725 1.4188 13.6562 2.34692C14.5844 3.27505 14.5844 4.78755 13.6562 5.71567L11.4094 7.96255C11.1 8.27192 11.1 8.77505 11.4094 9.08442C11.5656 9.24067 11.9906 9.55942 12.5312 9.08442L14.7781 6.83755C16.325 5.29067 16.325 2.77192 14.7781 1.22192ZM7.9625 11.4063L5.71875 13.65C4.81875 14.55 3.25 14.55 2.35 13.65C1.9 13.2 1.65313 12.6032 1.65313 11.9657C1.65313 11.3282 1.9 10.7313 2.35 10.2813L4.59375 8.03442C4.90312 7.72505 4.90312 7.22192 4.59375 6.91255C4.28438 6.60317 3.78125 6.60317 3.47187 6.91255L1.22812 9.15942C0.475 9.90942 0.0625 10.9063 0.0625 11.9688C0.0625 13.0282 0.475 14.025 1.225 14.775C1.975 15.525 2.97187 15.9375 4.03125 15.9375C5.09062 15.9375 6.0875 15.525 6.8375 14.775L9.08125 12.5313C9.39062 12.2219 9.39062 11.7188 9.08125 11.4094C8.77188 11.0969 8.27188 11.0969 7.9625 11.4063Z",
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1508 5.84995C9.84141 5.54058 9.33828 5.54058 9.02891 5.84995L5.06016 9.8187C4.75078 10.1281 4.75078 10.6312 5.06016 10.9406C5.21641 11.0968 5.64141 11.4062 6.18203 10.9406L10.1508 6.97183C10.4602 6.66245 10.4602 6.15933 10.1508 5.84995Z",
    fill: "#7E57C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_13964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copylink.e8f74f074b9b950863d99130b20a012c.svg";
export { ForwardRef as ReactComponent };